export default __webpack_public_path__ + "static/media/ILPlatform_Computer2.2b57c26b.png";